(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeHistorico', PropriedadeHistoricoDirective);

  function PropriedadeHistoricoDirective() {
    return {
      restrict: 'E',
      controller: 'PropriedadeHistoricoCtrl',
      controllerAs: 'hist',
      templateUrl: 'views/propriedade/historico/main.html',
      scope: {
        culturasPorGleba: '<',
        hasUnreadNotifications: '<',
        sharedData: '<'
      }
    };
  }
}());
